import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/index.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/CustomFormList/SmyMapAddress.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "create-order no-group-border"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('group', [_c('x-input', {
    attrs: {
      "readonly": "",
      "title": "",
      "placeholder": i18n.tc("239")
    },
    model: {
      value: _vm.template.service_name,
      callback: function ($$v) {
        _vm.$set(_vm.template, "service_name", $$v);
      },
      expression: "template.service_name"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(i18n.tc("69"))])])], 1), _vm.productId ? _c('group', [_c('x-input', {
    attrs: {
      "readonly": "",
      "title": "",
      "placeholder": i18n.tc("159")
    },
    model: {
      value: _vm.productMap.product_name,
      callback: function ($$v) {
        _vm.$set(_vm.productMap, "product_name", $$v);
      },
      expression: "productMap.product_name"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(i18n.tc("159"))])])], 1) : _vm._e(), _c('group', [_vm.template.is_enable_customer ? _c('x-input', {
    attrs: {
      "title": i18n.tc("241"),
      "placeholder": i18n.tc("239")
    },
    model: {
      value: _vm.systemFields.custom_name,
      callback: function ($$v) {
        _vm.$set(_vm.systemFields, "custom_name", $$v);
      },
      expression: "systemFields.custom_name"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]), _vm._v(" " + i18n.tc("241") + " ")])]) : _vm._e(), _vm.template.is_enable_customer ? _c('x-input', {
    attrs: {
      "type": "tel",
      "title": i18n.tc("157"),
      "placeholder": i18n.tc("239")
    },
    model: {
      value: _vm.systemFields.custom_phone,
      callback: function ($$v) {
        _vm.$set(_vm.systemFields, "custom_phone", $$v);
      },
      expression: "systemFields.custom_phone"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]), _vm._v(" " + i18n.tc("157") + " ")])]) : _vm._e(), _vm.template.is_enable_address ? _c(__unplugin_components_0, {
    attrs: {
      "defaultAddress": _vm.systemFields.map_name,
      "defaultLatLong": [_vm.systemFields.custom_longitude, _vm.systemFields.custom_latitude],
      "defaultCode": _vm.defaultCode,
      "type": _vm.systemFields.address_type
    },
    on: {
      "on-change": _vm.selectAddress
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]), _vm._v(" " + i18n.tc("242") + " ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.changeAddressList.length > 1,
      expression: "changeAddressList.length > 1"
    }],
    staticClass: "btn btn1",
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.showChangeAddress.show();
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/selectadress34_34@3x.png"
    }
  }), _c('span', [_vm._v(i18n.tc("243"))])])]) : _vm._e(), _vm.template.is_enable_detail_address ? _c('x-input', {
    attrs: {
      "title": i18n.tc("244"),
      "placeholder": i18n.tc("245"),
      "show-clear": true
    },
    model: {
      value: _vm.systemFields.custom_detail_addr,
      callback: function ($$v) {
        _vm.$set(_vm.systemFields, "custom_detail_addr", $$v);
      },
      expression: "systemFields.custom_detail_addr"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: 120 + 'px'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(i18n.tc("244"))])]) : _vm._e()], 1), _vm.template.is_enable_priority ? _c('group', [_c('popup-picker', {
    attrs: {
      "show-name": "",
      "title": i18n.tc("246"),
      "placeholder": i18n.tc("237"),
      "value-text-align": "right",
      "columns": 1,
      "data": _vm.priorityList
    },
    model: {
      value: _vm.priority,
      callback: function ($$v) {
        _vm.priority = $$v;
      },
      expression: "priority"
    }
  })], 1) : _vm._e(), _c(__unplugin_components_1, {
    ref: "customFormList",
    attrs: {
      "get-value-name": "",
      "data": _vm.fieldList
    },
    on: {
      "on-change": function ($event) {
        _vm.customFields = $event;
      }
    }
  }), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary",
      "show-loading": _vm.btnLoading,
      "disabled": _vm.btnLoading
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.btnLoading ? i18n.tc("234") : i18n.tc("247")) + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };